import React from 'react';
import { TrashBin } from '@gravity-ui/icons';
import { Select } from '@gravity-ui/uikit';
import { codeBlockType } from '../../../../extensions/markdown';
import { i18n } from '../../../../i18n/codeblock';
import { i18n as i18nPlaceholder } from '../../../../i18n/placeholder';
import { BaseTooltipPluginView } from '../../../../plugins/BaseTooltip';
import { Toolbar, ToolbarDataType } from '../../../../toolbar';
import { removeNode } from '../../../../utils/remove-node';
import { langAttr } from '../const';
import './TooltipView.css';
const CodeMenu = ({ view, pos, node, selectItems, mapping }) => {
    var _a;
    const lang = node.attrs[langAttr];
    const value = (_a = mapping[lang]) !== null && _a !== void 0 ? _a : lang;
    const handleClick = (type) => {
        view.focus();
        if (type === value)
            return;
        view.dispatch(view.state.tr.setNodeMarkup(pos, null, {
            [langAttr]: type,
        }));
    };
    return (React.createElement(Select, { size: "m", width: "max", value: [value], onUpdate: (v) => handleClick(v[0]), options: selectItems, filterable: true, filterPlaceholder: i18nPlaceholder('select_filter'), popupClassName: "ye-code-block__select-popup", className: "ye-code-block__select-button", renderEmptyOptions: () => (React.createElement("div", { className: "ye-code-block__select-empty" }, i18n('empty_option'))) }));
};
export const codeLangSelectTooltipViewCreator = (view, langItems, mapping = {}) => {
    return new BaseTooltipPluginView(view, {
        idPrefix: 'code-block-tooltip',
        nodeType: codeBlockType(view.state.schema),
        popupPlacement: ['bottom', 'top'],
        content: (view, { node, pos }) => (React.createElement(Toolbar, { editor: {}, focus: () => view.focus(), className: "ye-code-block-toolbar", data: [
                [
                    {
                        id: 'code-block-type',
                        type: ToolbarDataType.ReactComponent,
                        component: () => (React.createElement(CodeMenu, { view: view, pos: pos, node: node, selectItems: langItems, mapping: mapping })),
                        width: 28,
                    },
                ],
                [
                    {
                        id: 'code-block-remove',
                        icon: { data: TrashBin },
                        title: i18n('remove'),
                        type: ToolbarDataType.SingleButton,
                        isActive: () => false,
                        isEnable: () => true,
                        exec: () => removeNode({
                            pos: pos,
                            node: node,
                            tr: view.state.tr,
                            dispatch: view.dispatch.bind(view),
                        }),
                    },
                ],
            ] })),
    });
};
